<template>
  <b-tab title="Mağaza Ürünleri">
    <b-row class="border">
      <b-col cols="2">
        Mağaza
      </b-col>
      <b-col cols="2">
        Tedarikçi
      </b-col>
      <b-col cols="2">
        Stok Adedi
      </b-col>
      <b-col cols="2">
        Fiyat
      </b-col>
      <b-col cols="2">
        Termin
      </b-col>
    </b-row>
    <b-row v-for="storeProduct in storeProducts" :key="storeProduct.id" class="border">
      <b-col cols="2">
        {{ storeProduct.store.store_name }} ({{ storeProduct.store.marketplace_name }})
      </b-col>
      <b-col cols="2">
        {{ storeProduct.supplier ? storeProduct.supplier.name : '' }}
      </b-col>
      <b-col cols="2">
        {{ storeProduct.stock }}
      </b-col>
      <b-col cols="2">
        {{ storeProduct.price }}
      </b-col>
      <b-col cols="2">
        {{ storeProduct.deadline }}
      </b-col>
    </b-row>
  </b-tab>
</template>
<script>
export default {
  name: "StoreProductTab",
  props: {
    product: {
      type: Object,
      required: true,
    },
    storeProducts: {
      type: Array,
      required: true
    }
  }
}
</script>